export const BOOKING_URL =
  import.meta.env.VITE_BOOKING_URL ||
  "https://calendar.google.com/calendar/appointments";
